/**
 * Video-Fassade.
 *
 * YouTube wird erst nach einem aktiven Klick geladen. Vor dem Klick entsteht
 * keine Verbindung zu Drittanbietern und es werden keine Cookies gesetzt —
 * das ist schneller und fuer eine deutsche Website der saubere Weg.
 *
 * Erwartet:
 *   <div class="video" data-video-id="..." data-titel="...">
 *     <button class="video__fassade"> ... </button>
 *   </div>
 */
(function () {
  "use strict";

  var behaelter = document.querySelectorAll(".video[data-video-id]");
  if (!behaelter.length) return;

  Array.prototype.forEach.call(behaelter, function (box) {
    var fassade = box.querySelector(".video__fassade");
    if (!fassade) return;

    fassade.addEventListener("click", function () {
      var id = box.getAttribute("data-video-id");
      if (!id) return;

      var titel = box.getAttribute("data-titel") || "Video";

      var rahmen = document.createElement("iframe");
      // youtube-nocookie.de setzt erst beim Abspielen Cookies.
      rahmen.src =
        "https://www.youtube-nocookie.com/embed/" +
        encodeURIComponent(id) +
        "?autoplay=1&rel=0&modestbranding=1";
      rahmen.title = titel;
      rahmen.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
      rahmen.setAttribute("allowfullscreen", "");
      rahmen.setAttribute("loading", "lazy");
      rahmen.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");

      box.replaceChild(rahmen, fassade);
      rahmen.focus();
    });
  });
})();
